import playgroundReducer from "./playground/reducer";
import predictionsReducer from "./predictions/reducer";
import systemMessageReducer from "./systemMessage/reducer";

export default {
  systemMessage: systemMessageReducer,
  predictions: predictionsReducer,
  playground: playgroundReducer
};
